import React, { useMemo } from "react";

const COLORS = ["#4F46E5", "#DB2777", "#F59E0B", "#16A34A", "#0891B2", "#EF4444"];

export default function Confetti({ count = 80 }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 0.6,
        duration: 2.2 + Math.random() * 1.6,
        color: COLORS[i % COLORS.length],
        size: 6 + Math.random() * 7,
        rot: Math.random() * 360,
      })),
    [count]
  );
  return (
    <div className="pointer-events-none fixed inset-0 z-[100] overflow-hidden" data-testid="confetti">
      <style>{`
        @keyframes qf-confetti-fall {
          0% { transform: translateY(-12vh) rotate(0deg); opacity: 1; }
          100% { transform: translateY(110vh) rotate(720deg); opacity: 0.9; }
        }
      `}</style>
      {pieces.map((p) => (
        <span
          key={p.id}
          style={{
            position: "absolute",
            left: `${p.left}%`,
            top: 0,
            width: p.size,
            height: p.size * 0.5,
            backgroundColor: p.color,
            transform: `rotate(${p.rot}deg)`,
            borderRadius: 1,
            animation: `qf-confetti-fall ${p.duration}s ${p.delay}s cubic-bezier(.4,.1,.3,1) forwards`,
          }}
        />
      ))}
    </div>
  );
}
